var _defs, _g;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgAwaitingStream(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 460,
    height: 265,
    viewBox: "0 0 290 195",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.650000 0 0 0 0 0.650000 0 0 0 0 0.650000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)",
    opacity: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.61 42.719a3.516 3.516 0 0 0-3.516 3.515v5.548c0 9.708 7.87 17.578 17.578 17.578 9.708 0 17.578-7.87 17.578-17.578v-5.548a3.516 3.516 0 0 0-3.516-3.515H137.61z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.61 95.453a3.516 3.516 0 0 1-3.516-3.516V86.39c0-9.708 7.87-17.578 17.578-17.578 9.708 0 17.578 7.87 17.578 17.578v5.547a3.516 3.516 0 0 1-3.516 3.516H137.61zM136.384 60.297h30.576"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.019 95.212c-3.01-6.319-8.754-12.064-15.347-12.064s-12.338 5.745-15.347 12.064"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m82.444 130 1.162-2.912h4.172L88.954 130h1.344l-4.06-9.94h-1.064L81.1 130h1.344zm5.054-3.892h-3.64l1.848-4.592 1.792 4.592zM94.93 130l2.786-7.882 2.856 7.882h1.316l3.15-9.94h-1.428l-2.492 8.078-2.73-8.078h-1.372l-2.632 8.078-2.506-8.078h-1.414l3.15 9.94h1.316zm11.618 0 1.162-2.912h4.172l1.176 2.912h1.344l-4.06-9.94h-1.064l-4.074 9.94h1.344zm5.054-3.892h-3.64l1.848-4.592 1.792 4.592zm5.99 3.892v-9.94h-1.26V130h1.26zm6.718 0v-8.82h3.43v-1.12h-8.12v1.12h3.43V130h1.26zm6.718 0v-9.94h-1.26V130h1.26zm4.24 0v-7.616L141.26 130h1.148v-9.926h-1.26v7.756l-6.076-7.77h-1.064V130h1.26zm14.11.07c1.148 0 2.156-.462 3.024-1.414V130h1.064v-4.956h-3.206v.952h2.142v1.372c-.882 1.064-1.848 1.568-2.926 1.568-1.96 0-3.458-1.778-3.458-3.906 0-2.016 1.302-3.906 3.332-3.906 1.218 0 2.268.56 2.856 1.708l.966-.672c-.644-1.288-1.876-2.17-3.794-2.17-2.66 0-4.634 2.338-4.634 5.012 0 2.562 2.002 5.068 4.634 5.068zm14.01.028c2.044 0 3.612-.854 3.612-2.772 0-1.792-1.288-2.38-3.36-2.842-1.792-.406-2.618-.686-2.618-1.75 0-1.008.7-1.624 2.24-1.624 1.19 0 2.24.518 2.702 1.036l.588-1.022c-.84-.686-1.932-1.134-3.262-1.134-2.058 0-3.57 1.036-3.57 2.94 0 1.582 1.05 2.128 3.066 2.618 1.848.448 2.87.784 2.87 1.904 0 .994-.826 1.512-2.24 1.512-1.512 0-2.87-.7-3.472-1.33l-.602 1.064c1.12.91 2.52 1.4 4.046 1.4zm9.602-.098v-8.82h3.43v-1.12h-8.12v1.12h3.43V130h1.26zm6.718 0v-3.57h2.632l2.268 3.57h1.428l-2.408-3.808c1.26-.322 2.086-1.568 2.086-2.954 0-1.568-1.26-3.178-3.01-3.178h-4.256V130h1.26zm3.01-4.69h-3.01v-4.13h2.926c.966 0 1.806.938 1.806 2.058 0 1.092-.686 2.072-1.722 2.072zm12.276 4.69v-1.12h-5.488v-3.43h4.662v-1.05h-4.662v-3.22h5.362v-1.12h-6.622V130h6.748zm2.616 0 1.162-2.912h4.172L204.12 130h1.344l-4.06-9.94h-1.064l-4.074 9.94h1.344zm5.054-3.892h-3.64l1.848-4.592 1.792 4.592zm5.99 3.892v-7.588l3.29 5.838h.77l3.276-5.838V130h1.26v-9.94h-1.316l-3.612 6.454-3.598-6.454h-1.33V130h1.26z",
    fill: "#A6A6A6",
    fillRule: "nonzero"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwaitingStream);
export default __webpack_public_path__ + "static/media/awaiting-stream.74d7d2eb.svg";
export { ForwardRef as ReactComponent };